const TopHashtagsReport = {

	visual: {
		icon: "va-icon fa fa-bar-chart",
		title: "Top Hashtag Report",
		desc: "Return the top used hashtags across the retrieved data."
	},

	binding: [
		{"top_hashtags_limit": "number", "label":"Hashtag Limit"},
	],

	query:`
		CALL algo.pageRank.stream('Hashtag,Status,Account','HASHTAG',{iterations:1000, dampingFactor:0.50,write: false})
		YIELD nodeId, score
		WITH
			algo.asNode(nodeId) as tag_tmp,score
		CALL 
			apoc.create.vNode(['tag'],{node:tag_tmp.hashtag,score:score}) 
        YIELD node as Tag
		RETURN Tag
		ORDER BY score DESC LIMIT :top_hashtags_limit;
	`,

	config:{
		console_debug:true,
		labels: {
			"tag": {
				"caption": "node",
				"size": "score",
				"community": "HASHTAG"
			}
		}
	}
	
}

export default TopHashtagsReport;
